import {Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {SpinnerService} from '~shared/components/buttons/spinner/spinner.service';
import {FormLabelTranslationService} from '~shared/components/form-fields/translations/form-label-translations.service';
import {ProcessConfigurationsType} from '~core/enum';
import {ProcessConfigurationService} from '~core/services';
import {TooltipTranslationService} from '~shared/translations';
import {Lottery, ProcessConfiguration} from '~core/models';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

/**
 * Displays process configuration information
 */
@UntilDestroy()
@Component({
  selector: 'app-process-configuration-info',
  templateUrl: './process-configuration-info.component.html',
})
export class ProcessConfigurationInfoComponent implements OnInit {
  @Input() public selectedLottery: Lottery;
  public processConfiguration: ProcessConfiguration;
  public spinnerName: string = 'configurationLoading';
  public spinnerLoading: boolean = true;

  constructor(
    public tooltipTranslations: TooltipTranslationService,
    public tixxSelectOverviewService: EventAdministrationService,
    private spinnerService: SpinnerService,
    private flTranslations: FormLabelTranslationService,
    private processConfigurationService: ProcessConfigurationService,
  ) {
    this.processConfigurationService.castCurrentProcessConfiguration.pipe(untilDestroyed(this))
      .subscribe((data: ProcessConfiguration) => this.processConfiguration = data);
  }

  ngOnInit(): void {
    this.getProcessConfiguration();
  }

  /**
   * Opens the edit configuration sidebar
   */
  public editProcessConfiguration(): void {
    this.tixxSelectOverviewService.toggleAllModal(false);
    this.tixxSelectOverviewService.toggleEditProcessConfigurationModal(true);
  }

  /**
   * Gets the correct key and translated it
   */
  // eslint-disable-next-line complexity
  getTranslatedKey(key: string | boolean): string {
    let translatedKey = '';
    switch (key) {
      case ProcessConfigurationsType.DEACTIVATED:
        translatedKey = this.flTranslations.i18nDeactivated;
        break;
      case ProcessConfigurationsType.HIGHER:
        translatedKey = this.flTranslations.i18nHigher;
        break;
      case ProcessConfigurationsType.LOWER:
        translatedKey = this.flTranslations.i18nLower;
        break;
      case ProcessConfigurationsType.BOTH:
        translatedKey = this.flTranslations.i18nBoth;
        break;
      case false:
        translatedKey = this.flTranslations.i18nDeactivated;
        break;
      case true:
        translatedKey = this.flTranslations.i18nActivated;
        break;
      default:
    }
    return translatedKey;
  }

  /**
   * Function that fetches process configuration data
   */
  public getProcessConfiguration(): void {
    this.processConfigurationService.get(this.selectedLottery.id)
      .subscribe((data: any) => {
        if (data) {
          this.processConfigurationService.setCurrentProcessConfiguration(data);
          this.spinnerService.hide(this.spinnerName);
        }
      });
  }

}
